import template from './SubscriptionOption.jade';
import { SubscriptionOptionController } from './SubscriptionOption.controller';

export const SubscriptionOption = () => {
  return {
    template,
    scope: {},
    bindToController: {
      option: '=',
    },
    controller: SubscriptionOptionController,
    controllerAs: 'subscriptionOptionCtrl',
    replace: true,
  };
};
